import React from 'react';
import "./Notification.css";

import { NotificationContext } from "./NotificationContext.js"

import closeIcon from "./Resources/Icons/close.svg";

/**
 * @description Notification element that displays its content then disappears if no user input is present
 * */
export class Notification extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            disappearing: false,
        };

        this.timeout = null;
    }

    /**
     * @description Destroy the notification after playing a leave animation
     * */
    destroySelf() {
        clearTimeout(this.timeout);

        setTimeout(() => this.context.removeNotification(this.props.notification), this.props.transitionDelay);

        this.setState({ disappearing: true });
    }

    /**
     * @description Stops the countdown, preventing the notification from disappearing
     * */
    stopTimer() {
        if (!this.state.disappearing) {
            clearTimeout(this.timeout);
        }
    }

    /**
     * @description Starts disappearing countdown
     * */
    startTimer() {
        if (!this.props.notification.isPermanent && !this.state.disappearing) {
            this.timeout = setTimeout(() => this.destroySelf(), this.props.lifetime);
        }
    }

    componentDidMount() {
        this.startTimer();
    }

    render() {
        let animation = this.state.disappearing ? "disappearing" : "appearing";

        return (
            <div className={`notification ${this.props.notification.className} ${animation}`} onMouseEnter={() => this.stopTimer()} onMouseLeave={() => this.startTimer()}>
                {this.props.notification.icon !== null && < img className="notification-icon" src={this.props.notification.icon} alt="" width="32" height="32" />}

                <div>
                    <div className="notification-header">
                        {this.props.notification.title}
                    </div>

                    <div className="notification-description" >
                        {this.props.notification.description}
                    </div>
                </div>

                <button className="close-button" onClick={() => this.destroySelf()}>
                    <img src={closeIcon} alt="" width="16" height="16" />
                </button>
            </div>
        );
    }
}

Notification.contextType = NotificationContext;
